import Vue from "vue";
import Router from "vue-router";
import Home from "../views/Home.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    // {
    //     path: '/',
    //     name: 'index',
    //     redirect: '/introduce',
    //     component: Index,
    //     children: [
    //         {
    //             path: '/introduce',
    //             name: 'introduce',
    //             component: () => import('../views/Introduce.vue')
    //         },
    //         {
    //             path: '/public',
    //             name: 'public',
    //             component: () => import('../views/Public.vue')
    //         },
    //         {
    //             path: '/about',
    //             name: 'about',
    //             component: () => import('../views/About.vue')
    //         },
    //         {
    //             path: '/login',
    //             name: 'login',
    //             component: () => import('../views/Login.vue')
    //         },
    //     ]
    // },
    {
      path: "/",
      name: "/index",
      meta: {
        title: "传联——传播正能量，联袂万古亲",
      },
      component: () => import("../views/Index.vue"),
    },
    {
      path: "/square",
      name: "square",
      component: () => import("../views/Square.vue"),
      meta: {
        title: "传联社区——生活新知的快乐分享",
      },
    },
    {
      path: "/about",
      name: "about",
      component: () => import("../views/About.vue"),
      meta: {
        title: "关于传联",
      },
    },
    {
      path: "/login",
      name: "login",
      component: () => import("../views/Login.vue"),
      meta: {
        title: "登录传联",
      },
    },
    {
      path: "/weixinShare",
      name: "WeixinShare",
      component: () => import("../views/WeixinShare.vue"),
      meta: {
        title: "微信分享",
      },
    },
    {
      path: "/wxShopDetail",
      name: "wxShopDetail",
      component: () => import("../views/WeixinShareShop.vue"),
      meta: {
        title: "店铺详情",
      },
    },
    {
      path: "/imageView",
      name: "ImageView",
      component: () => import("../views/common/ImageViewer.vue"),
      meta: {
        title: "浏览图片",
      },
    },
    {
      path: "/home",
      name: "home",
      redirect: "/tree",
      component: Home,
      children: [
        {
          path: "/contacts",
          name: "contacts",
          component: () => import("../views/Contacts.vue"),
          meta: {
            title: "传联——海内存传联，天涯若比邻",
          },
        },
        {
          path: "/feeds",
          name: "feeds",
          component: () => import("../views/Feeds.vue"),
          meta: {
            //keepAlive: false, //此组件不需要被缓存
            title: "亲友小区——亲朋新情的即时沟通",
          },
        },
        {
          path: "/community",
          name: "community",
          component: () => import("../views/Community.vue"),
          meta: {
            title: "传联社区——生活新知的快乐分享",
          },
        },
        // {
        //     path: '/users',
        //     name: 'users',
        //     props: (route) => ({ query: route.query.id }),
        //     component: () => import('../views/Users.vue'),
        // },
        {
          path: "/users",
          name: "users",
          component: () => import("../views/Users.vue"),
          children: [
            {
              path: "/feed",
              name: "UserFeed",
              props: (route) => ({ query: route.query.id }),
              component: () => import("../views/user/UserFeed.vue"),
              meta: {
                title: "传联用户动态",
              },
            },
            {
              path: "/account",
              name: "UserAccount",
              component: () => import("../views/user/UserAccount.vue"),
              meta: {
                title: "传联用户帐号",
              },
            },
            {
              path: "/profile",
              name: "UserData",
              component: () => import("../views/user/UserData.vue"),
              meta: {
                title: "传联用户资料",
              },
            },
            {
              path: "/safety",
              name: "UserSafety",
              component: () => import("../views/user/UserSafety.vue"),
              meta: {
                title: "传联帐号安全",
              },
            },
            {
              path: "/tree",
              name: "UserTree",
              component: () => import("../views/user/UserTree.vue"),
              meta: {
                title: "传联用户家谱",
              },
            },
            {
              path: "/article",
              name: "UserArticle",
              component: () => import("../views/user/UserArticle.vue"),
              meta: {
                title: "传联用户文章",
              },
            },
            {
              path: "/album",
              name: "UserAlbum",
              component: () => import("../views/user/UserAlbum.vue"),
              meta: {
                title: "传联用户相册",
              },
            },
            {
              path: "/video",
              name: "UserVideo",
              component: () => import("../views/user/UserVideo.vue"),
              meta: {
                title: "传联用户视频",
              },
            },
            {
              path: "/audio",
              name: "UserAudio",
              component: () => import("../views/user/UserAudio.vue"),
              meta: {
                title: "传联用户音频",
              },
            },
            {
              path: "/follow",
              name: "UserFollow",
              props: (route) => ({ query: route.query.id }),
              component: () => import("../views/user/UserFollow.vue"),
              meta: {
                title: "传联用户关注",
              },
            },
            {
              path: "/fans",
              name: "UserFans",
              props: (route) => ({ query: route.query.id }),
              component: () => import("../views/user/UserFans.vue"),
              meta: {
                title: "传联用户粉丝",
              },
            },
          ],
        },
      ],
    },
    {
      path: "/register",
      name: "register",
      component: () => import("../views/Register.vue"),
      meta: {
        title: "注册传联",
      },
    },
    {
      path: "/handlianSdkList",
      name: "handlianSdkList",
      component: () => import("../views/HandlianSdkList.vue"),
      meta: {
        title: "传联APP接入第三方SDK情况",
      },
    },
    {
      path: "/forget",
      name: "forget",
      component: () => import("../views/ForgetPsw.vue"),
      meta: {
        title: "重置密码",
      },
    },
    {
      path: "/detail",
      name: "detail",
      component: () => import("../views/Detail.vue"),
      meta: {
        title: "传联动态详情",
      },
    },
    {
      path: "/adDetail",
      name: "adDetail",
      component: () => import("../views/AdDetail.vue"),
      meta: {
        title: "传联广告详情",
      },
    },
    {
      path: "/bigTree",
      name: "BigTree",
      props: (route) => ({ query: route.query.type }),
      component: () => import("../views/BigTree.vue"),
      meta: {
        title: "放大家谱",
      },
    },
    {
      path: "/clanTree",
      name: "ClanTree",
      component: () => import("../views/ClanTree.vue"),
      meta: {
        title: "族谱",
      },
    },
    {
      path: "/clanFeed",
      name: "ClanFeed",
      component: () => import("../views/ClanFeed.vue"),
      meta: {
        title: "查看族窗",
      },
    },
    {
      path: "/versionFamily",
      name: "VersionFamily",
      props: (route) => ({ query: route.query.id }),
      component: () => import("../views/VersionFamily.vue"),
      meta: {
        title: "家谱版本历史",
      },
    },
    {
      path: "/versionTree",
      name: "VersionTree",
      props: (route) => ({ query: route.query.id }),
      component: () => import("../views/VersionTree.vue"),
      meta: {
        title: "家谱版本历史",
      },
    },
    {
      path: "*",
      name: "error",
      component: () => import("../views/Error.vue"),
      meta: {
        title: "您走丢了",
      },
    },
  ],
  scrollBehavior(to, from, savePosition) {
    if (savePosition) {
      setTimeout(function() {
        document.documentElement.scrollTop = savePosition.y;
      }, 800);
    }
  },
});

router.beforeEach((to, from, next) => {
  const isLogin = sessionStorage.userInfo ? true : false;
  window.document.title = to.meta.title == undefined ? "传联" : to.meta.title;
  // if (to.path == '/login' || to.path == '/register') {
  //     next();
  // } else {
  //     isLogin ? next() : next('/login');
  // }
  // if (to.meta.title) {
  //     document.title = to.meta.title
  // }
  let destination = to.path;
  // let actions = [
  //     '/introduce',
  //     '/public',
  //     '/about',
  //     '/login',
  //     '/register'
  // ];
  let actions = [
    "/",
    "/public",
    "/about",
    "/login",
    "/register",
    "/forget",
    "/weixinShare",
    "/wxShopDetail",
    "/imageView",
  ];
  if (isLogin) {
    switch (destination) {
      case "/login":
        const isLogout = sessionStorage.LOGOUT ? true : false;
        if (isLogout) {
          next();
        } else {
          next("/home");
        }
        break;
      case "/square":
        next("/community");
        break;
      default:
        next();
        break;
    }
  } else {
    next();
    // if (actions.indexOf(destination) >= 0) {
    //     next();
    // } else {
    //     next('/login');
    // }
  }
});

export default router;
